import { render } from "./ShowSoilExamination.vue?vue&type=template&id=fdd66510"
import script from "./ShowSoilExamination.vue?vue&type=script&lang=js"
export * from "./ShowSoilExamination.vue?vue&type=script&lang=js"

import "./ShowSoilExamination.vue?vue&type=style&index=0&id=fdd66510&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__